<template>
  <div>
      <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="info"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="动态类型">
        <el-select
            class="search-el"
            size="mini"
            v-model="info.moment_type"
            placeholder="请选择"
            clearable
            :disabled="info.id > 0"
        >
          <el-option
              v-for="item in categoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="助教">
        <el-select
            class="search-el"
            size="mini"
            v-model="info.teacher_id"
            placeholder="请选择"
            clearable
            filterable
            :disabled="info.id > 0"
        >
          <el-option
              v-for="item in teacherList"
              :key="item.id"
              :label="item.real_name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="文字内容">
        <el-input
            type="textarea"
            rows="4"
            v-model="info.title"
            style="width:33%"
        ></el-input>
      </el-form-item>


      <el-form-item  label="动态图片" prop="images">
        <el-upload class="uploader"  :action="ossAction"  :auto-upload="true"
                   :file-list="fileList" list-type="picture-card" :limit="limit?limit:9" :accept="fileType?fileType:'image/*'"
                    :before-upload="beforeImageUpload"  :multiple="true"
                   ref="fileupload" :on-exceed="handleUploadExceed" :on-remove="handleRemove" :http-request="uploadImagesOSSRequest"
                   :on-preview="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :append-to-body="true" :visible.sync="dialogImgVisible" style="z-index: 3000;text-align: center;"
                   :close-on-click-modal="false" :close-on-press-escape="false" custom-class="pub_dialog">
          <img width="80%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item>

      <el-form-item label="视频">
        <el-upload
            class="avatar-uploader"
            action="ossAction"
            :http-request="videoUploadOSSRequest"
            :show-file-list="false"
            :before-upload="beforeVideoUpload"
        >
          <video v-if="info.media_url" :src="info.media_url" controls  class="video" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传mp4、m4v文件，且不超过20M
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="发布时间">
        <el-date-picker
            v-model="info.released_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择发布时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="
            createUpdate()
          "
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>
    <div class="hides" v-if="isshow">
      <i style="margin-top: 20px; font-size: 40px" class="el-icon-loading"> </i
      ><br />
      正在上传
    </div>
  </div>
</template>

<script>
import tinymce from '@/components/tinymce.vue';

import {
  beforeImageUpload,
  beforeVideoUpload,
  uploadOSSRequest,
  getAliyunOssToken,
  getMomentType,
} from "@/api/common";

import {
  getAssistantName
} from "@/api/assistant";
import {
  createUpdate,
  getDetail,
} from "@/api/video";
import { PrefixSource } from "webpack-sources";

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 9
    },
    fileType: String,
  },
  computed: {
    // ['xxx', 'xxx'] 转换为 [{url: 'xxx'}, {url: 'xxx'}]
    /*fileList() {
      return this.value.map(url => ({
        url
      }))
    }*/
  },
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      teacherList: [],
      categoryList: [],
      categoryOptions:[
        {key:1,value:"研习社"},
        {key:2,value:"遇见门票"},
      ],
      meetStoryList:[],
      editor: null,
      info: {
        id: 0,
        title: "",
        img_url: "",
        media_url: "",
        virtual_likes: 0,
        category_id: "",
        teacher_id: "",
        released_at: "",
        moment_type: "",
        images: []
      },
      UPLOAD_URL: "/v1/admin/common/upload", // 上传的图片服务器地址 即上传图片后台接口的路径
      /*loading: '',*/
      param: {
        token: ''
      },
      dialogImageUrl: "",
      dialogImgVisible: false,
      disabled: false,
      images:[],
      num:0,
      fileNum:0,
      fileList:[]
    };
  },
  components: {
    tinymce,
  },
  created: function () {
    getMomentType({  }).then((response) => {
      this.categoryList = response.data;
    });
    getAssistantName().then((response) => {
      this.teacherList = response.data;
      this.info.teacher_id = this.$route.query.teacher_id
    });
    this.info.id = this.$route.query.id;
    if (this.info.id > 0) {
      this.getInfo();
    }
  },
  mounted() {
  },
  methods: {
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.studentStoryInfo.avatar = fileUrl
        });
      });
    },

    /*getInfo() {
      this.loading = true;
      getStudentStoryInfo({
        id: this.studentStoryInfo.id,
      }).then((response) => {
        this.studentStoryInfo = response.data;
        this.loading = false;
        var list = [];
        this.studentStoryInfo.images.forEach(function (e){
          list.push({
            url:e
          })
        })
        this.fileList = list
        /!*this.value = this.studentStoryInfo.images;*!/
      });
    },*/
    getInfo() {
      this.loading = true;
      getDetail({
        id: this.info.id,
      }).then((response) => {
        this.info = response.data;
        this.loading = false;
        let list = [];
        this.info.images.forEach(function (e){
          list.push({
            url:e.img
          })
        })
        this.fileList = list
      });
    },
/*    createUpdateMeetStory() {
      this.updateLoading = true;
      createUpdateStudentStory(this.studentStoryInfo)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            if(this.$route.query.category == 2){
              this.$router.push({
                path: "/story/meetStudentStoryList",
                query: {
                  id: this.$route.query.meet_story_id,
                  category: this.$route.query.category,
                }
              });
            }else{
              this.$router.push({
                path: "/story/studentStoryList",
                /!*query: {
                  category: this.$route.query.category,
                }*!/
              });
            }

          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },*/
    createUpdate() {
      this.updateLoading = true;
      this.info.type = 4;
      createUpdate(this.info)
          .then((response) => {
            this.updateLoading = false;
            if (response.code == 1) {
              this.$message.success(response.message);
              this.$router.push({
                path: "/assistant/treadsList",
                query: {
                  id: this.info.teacher_id,
                }
              });
            }
          })
          .catch((err) => {
            this.updateLoading = false;
          });
    },

    ref() {
      window.history.go(-1);
    },

    //*********多图上传添加内容 开始*********

    //多图上传方法
    uploadImagesOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          let imageUrl = fileUrl;
          this.info.images.push({img:imageUrl});
          this.num++;
          if(this.num == this.fileNum){
            this.num = 0;
            this.fileNum = 0;
            // 这里如果 this.value.push(imageUrl) 这么写，vue会报出警告，大概意思是value作为props不应该在子组件中被修改
            // 应该根据 value 得到新的值，而不能修改它，this.value.concat(imageUrl)也是可以的，concat方法返回新的数组
            // this.$emit('input', [...this.value, imageUrl])
            this.$emit('input', this.value.concat(this.info.images))
            this.info.images =[];
          }
        });
      });
    },

    handlePictureCardPreview: function(file) {
      this.dialogImageUrl = file.url;
      this.dialogImgVisible = true;
    },
    handleRemove: function(file, fileList) {
      console.log(fileList)
      // fileList 为删除后的文件列表
      const value = [];
      fileList.forEach(function (item,index){
        value[index] = {img:item.url}
      })
      console.log(value)
      this.info.images = value;
      console.log(this.info.images)
      this.$emit('input', value)
    },
    handleGoodsImagesUploadSuccess(response, file, fileList) {

      if (response.code == 200) {
        let imageUrl = response.data;
        this.info.images.push(imageUrl);
        this.num++;
        if(this.num == this.fileNum){
          this.num = 0;
          this.fileNum = 0;
          // 这里如果 this.value.push(imageUrl) 这么写，vue会报出警告，大概意思是value作为props不应该在子组件中被修改
          // 应该根据 value 得到新的值，而不能修改它，this.value.concat(imageUrl)也是可以的，concat方法返回新的数组
          // this.$emit('input', [...this.value, imageUrl])
          this.$emit('input', this.value.concat(this.info.images))
          this.info.images = [];
        }
      } else {
        this.$message.error(file.name + '上传失败!');
      }
    },
    handlebeforeUpload(file) {
      // 这里做可以做文件校验操作
      const isImg = /^image\/\w+$/i.test(file.type)
      if (!isImg && this.fileType == 'image/*') {
        this.$message.error('只能上传 JPG、PNG、GIF 格式!')
        return false
      }
      this.fileNum++;
    },
    handleUploadExceed() {
      this.$message.error(`最多上传${this.limit}张图片`)
    },
    //*******多图上传 结束*******

    beforeVideoUpload(file) {
      beforeVideoUpload(file);
      this.isshow = true;
    },
    videoUploadOSSRequest(file) {
      getAliyunOssToken({ dir: "video/short_video/" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.info.media_url = fileUrl;
          this.isshow = false;
        });
      });
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>